import { render } from "./DocumentNotifications.vue?vue&type=template&id=320dcf1c&scoped=true&ts=true"
import script from "./DocumentNotifications.vue?vue&type=script&lang=ts"
export * from "./DocumentNotifications.vue?vue&type=script&lang=ts"

import "./DocumentNotifications.vue?vue&type=style&index=0&id=320dcf1c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320dcf1c"]])

export default __exports__